import '../../styles/editcase/RiskScoreBanner.css';

const RECOMMENDATION_LABELS = {
    accept: 'Accept',
    clarify: 'Clarify',
    decline: 'Decline / Hold',
};

const RISK_LABELS = {
    low: 'low risk',
    medium: 'medium risk',
    high: 'high risk',
};

export default function RiskScoreBanner({ riskScore, recommendation }) {
    if (!riskScore || !recommendation) return null;
    const recLabel = RECOMMENDATION_LABELS[recommendation] || recommendation;
    const riskLabel = RISK_LABELS[riskScore] || riskScore;
    return (
        <div className={`risk-banner risk-banner--${riskScore}`}>
            <span className="risk-banner-recommendation">{recLabel}</span>
            <span className="risk-banner-risk">({riskLabel})</span>
        </div>
    );
}
